module.exports = "/images/pt_BR.svg";